import { WHATSAPP_NUMBER } from "@/lib/business";

/** Icône WhatsApp (glyphe officiel, tracé plein). */
export function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.174.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 0 1 6.988 2.896 9.82 9.82 0 0 1 2.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.359.101 11.945c0 2.096.549 4.142 1.595 5.945L0 24l6.305-1.654a11.9 11.9 0 0 0 5.683 1.448h.005c6.585 0 11.946-5.359 11.949-11.945a11.9 11.9 0 0 0-3.421-8.4" />
    </svg>
  );
}

function waHref(message: string) {
  // wa.me ouvre l'application sur mobile et WhatsApp Web sur ordinateur.
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

/**
 * Bouton WhatsApp en ligne.
 *
 * Ne rend rien tant qu'aucun numéro n'est renseigné dans `lib/business.ts` :
 * un lien `wa.me/` sans numéro ouvre une erreur WhatsApp, ce qui est pire que
 * pas de bouton du tout.
 */
export function WhatsAppLink({
  label,
  message,
  className = "",
}: {
  label: string;
  message: string;
  className?: string;
}) {
  if (!WHATSAPP_NUMBER) return null;

  return (
    <a
      href={waHref(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-rl-track="global:whatsapp"
      className={`inline-flex items-center gap-2 rounded-lg bg-[#25D366] px-6 py-3 text-sm font-medium text-[#07301c] transition-opacity hover:opacity-90 ${className}`}
    >
      <WhatsAppIcon className="h-4 w-4" />
      {label}
    </a>
  );
}

/*
 * Il n'y a délibérément pas de bulle flottante SUR cette page : elle porte déjà
 * deux boutons « Écrivez-nous sur WhatsApp », en tête et en pied. Une pastille
 * par-dessus ferait doublon. La bulle flottante vit dans `market-invite.tsx`,
 * et sert à amener ICI les visiteurs dominicains depuis le reste du site.
 */
